import { AbortControllerFacade } from '../abort-controller';
import { requestWithAbort } from '../use-service';
import { TeamsPermissionApi } from './types';
export const urlGetPermissions = ({
  orgId,
  siteId,
  apiVersion
}) => `/gateway/api/${apiVersion}/teams/permission/self/organization/${orgId}${apiVersion === 'v4' ? `?siteId=${siteId}` : ''}`;
export const requestPermissions = ({
  orgId,
  ...props
}) => orgId ? requestWithAbort(urlGetPermissions({
  ...props,
  orgId
}), {
  method: 'GET'
}) : [() => Promise.resolve(), new AbortControllerFacade()];
export const transformPermissions = permissions => {
  return permissions.reduce((acc, permission) => {
    switch (permission) {
      case TeamsPermissionApi.canCreateTeams:
        return {
          ...acc,
          canCreateTeams: true
        };
      case TeamsPermissionApi.canViewTeams:
        return {
          ...acc,
          canViewTeams: true
        };
      case TeamsPermissionApi.canAdminTeams:
        return {
          ...acc,
          canAdminTeams: true
        };
      default:
        return acc;
    }
  }, {
    canCreateTeams: false,
    canViewTeams: false,
    canAdminTeams: false
  });
};